"use client";
/**
 * Standalone wrapper around the marketing design-system `Footer` so the rich,
 * dark landing-page footer can be dropped onto pages that live *outside* the
 * `(marketing)` route group (e.g. /pricing, /ai, /status).
 *
 * The DS `Footer` relies on the `.svendetid-ds` token scope and the DM Sans /
 * Newsreader font variables that the marketing layout normally provides. Here we
 * inject those tokens (and the responsive `footer-grid` rules) ourselves so the
 * footer renders identically anywhere it is used.
 */
import { Footer, dsFontClass, dsTokensCss, type Lang } from "@/app/(marketing)/_components/svendetid-ds";

export default function LandingFooter({
  lang = "da",
  daHref,
  enHref,
}: {
  lang?: Lang;
  daHref: string;
  enHref: string;
}) {
  return (
    <div className={`svendetid-ds ${dsFontClass}`}>
      <style dangerouslySetInnerHTML={{ __html: dsTokensCss }} />
      <Footer lang={lang} daHref={daHref} enHref={enHref} />
    </div>
  );
}
